import { FC, ReactNode } from "react";

import Stack from "@mui/material/Stack";

import { DashboardTypography } from "@/dashboard-design-system/Typography";

export interface SectionProps {
  title: string;
  description: string;
  children: ReactNode;
  onInteract?: () => void;
  "data-test"?: string;
}

export const Section: FC<SectionProps> = ({ title, description, children, onInteract, "data-test": dataTest }) => (
  <Stack spacing={2} onFocusCapture={onInteract} onPointerDownCapture={onInteract} data-test={dataTest}>
    <Stack spacing={0.5}>
      <DashboardTypography variant="h6" vibe="text-neutral-intense">
        {title}
      </DashboardTypography>
      <DashboardTypography variant="body1" vibe="text-neutral-moderate">
        {description}
      </DashboardTypography>
    </Stack>
    {children}
  </Stack>
);
